import React, { useEffect, useRef } from 'react';

function CourtVisualization({ team }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current || team.length === 0) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    // Set canvas size
    const width = 500;
    const height = 470;
    canvas.width = width;
    canvas.height = height;

    // Colors
    const courtBg = '#EAD8C0';  // Light brown
    const courtLine = '#C12020';  // Red
    const lineWidth = 2.5;

    // Clear and set background
    ctx.fillStyle = courtBg;
    ctx.fillRect(0, 0, width, height);

    // Court dimensions (scaled)
    const courtW = width;
    const courtH = height;
    const keyW = 160;
    const keyH = 190;
    const ftRadius = 60;
    const rim = { x: courtW / 2, y: 52.5, r: 7.5 };
    const arcR = 237.5;

    ctx.strokeStyle = courtLine;
    ctx.lineWidth = lineWidth;

    // Draw court outline
    ctx.beginPath();
    ctx.rect(0, 0, courtW, courtH);
    ctx.stroke();

    // Draw key (paint area)
    const keyX1 = (courtW - keyW) / 2;
    const keyX2 = (courtW + keyW) / 2;

    ctx.beginPath();
    ctx.rect(keyX1, 0, keyW, keyH);
    ctx.stroke();

    // Draw free throw circle
    ctx.beginPath();
    ctx.arc(courtW / 2, keyH, ftRadius, 0, Math.PI * 2);
    ctx.stroke();

    // Draw rim
    ctx.beginPath();
    ctx.arc(rim.x, rim.y, rim.r, 0, Math.PI * 2);
    ctx.stroke();

    // Draw 3-point arc
    ctx.beginPath();
    ctx.arc(rim.x, rim.y, arcR, Math.PI * 0.12, Math.PI * 0.88);
    ctx.stroke();

    // Draw 3-point corners
    ctx.beginPath();
    ctx.moveTo(rim.x - 220, 0);
    ctx.lineTo(rim.x - 220, 140);
    ctx.stroke();

    ctx.beginPath();
    ctx.moveTo(rim.x + 220, 0);
    ctx.lineTo(rim.x + 220, 140);
    ctx.stroke();

    // Draw backboard
    ctx.beginPath();
    ctx.moveTo(rim.x - 30, 40);
    ctx.lineTo(rim.x + 30, 40);
    ctx.stroke();

    // Player positions on court
    const positions = {
      'PG': { x: courtW / 2, y: 220 },
      'SG': { x: 150, y: 140 },
      'SF': { x: 150, y: 60 },
      'PF': { x: 350, y: 60 },
      'C': { x: 350, y: 140 }
    };

    // Draw players
    team.forEach(player => {
      const pos = positions[player.position_assigned];
      if (!pos) return;

      // Position colors
      const posColors = {
        'PG': '#3B82F6',  // blue
        'SG': '#10B981',  // green
        'SF': '#F59E0B',  // amber
        'PF': '#EF4444',  // red
        'C': '#8B5CF6'    // purple
      };

      const color = posColors[player.position_assigned] || '#6B7280';

      // Draw position circle
      ctx.fillStyle = color;
      ctx.beginPath();
      ctx.arc(pos.x, pos.y, 30, 0, Math.PI * 2);
      ctx.fill();

      // Draw position label
      ctx.fillStyle = 'white';
      ctx.font = 'bold 14px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'top';
      ctx.fillText(player.position_assigned, pos.x, pos.y - 7);

      // Draw player name
      ctx.fillStyle = '#1F2937';
      ctx.font = 'bold 11px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'top';

      // Split long names
      const name = player.player_name;
      const maxWidth = 80;
      const words = name.split(' ');

      if (ctx.measureText(name).width > maxWidth && words.length > 1) {
        ctx.fillText(words[0], pos.x, pos.y + 35);
        ctx.fillText(words.slice(1).join(' '), pos.x, pos.y + 48);
      } else {
        ctx.fillText(name, pos.x, pos.y + 35);
      }
    });

  }, [team]);

  return (
    <div style={{ textAlign: 'center' }}>
      <canvas
        ref={canvasRef}
        style={{
          maxWidth: '100%',
          height: 'auto',
          borderRadius: '8px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}
      />
    </div>
  );
}

export default CourtVisualization;
